// @noflow
import { useCallback, useState } from 'react';
import { redirectUrl } from '../utils/softQuoteUtil';

const useApplyUrl = () => {
  const [applyUrl, setUrl] = useState(redirectUrl());

  const setApplyUrl = useCallback((currentUrl: string): void => {
    setUrl(currentUrl);
  }, []);

  return {
    applyUrl,
    setApplyUrl
  };
};

export default useApplyUrl;
